import { render, staticRenderFns } from "./shipper_account_info.vue?vue&type=template&id=469130c4&scoped=true&"
import script from "./shipper_account_info.vue?vue&type=script&lang=js&"
export * from "./shipper_account_info.vue?vue&type=script&lang=js&"
import style0 from "./shipper_account_info.vue?vue&type=style&index=0&id=469130c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469130c4",
  null
  
)

export default component.exports